import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import '../css/Login.css';
import '../css/Main.css';

const LoginPage = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: 'create',
      })
      .catch((error) => console.log(error));
  };
  return (
    <div className="login-page">
      <div className="login-logo-container">
        <img
          className="login-logo"
          src={`${process.env.PUBLIC_URL}/AmbaFlex_LogoSIS.jpg`}
          alt="Logo"
        />
      </div>
      <div className="login-container">
        <p>Sign in to continue</p>
        <button className="button-md button-primary" onClick={handleLogin}>
          Sign in
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
